import { ReactComponent as CloseIcon } from '../../common/icons/close.svg';
import { ReactComponent as ChevronLeftIcon } from '../../common/icons/chevronLeft.svg';

interface DiscountHeaderProps {
  title: string;
  onStepBack: () => void;
  onClose: () => void;
}

export function DiscountHeader({
  title,
  onStepBack,
  onClose,
}: DiscountHeaderProps) {
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-2 -top-2.5 -left-2.5 relative">
        <div
          className="p-2.5 hover:cursor-pointer [&>svg]:text-gray-600  [&>svg]:hover:text-gray-800  [&>svg]:active:text-gray-900"
          onClick={onStepBack}
        >
          <ChevronLeftIcon />
        </div>
        <h1 className="text-heading-lg text-gray-900">{title}</h1>
      </div>

      <button
        className="DiscountScreen-Close p-2.5 -right-2.5 -top-2.5 relative hover:cursor-pointer [&>svg]:fill-gray-600  [&>svg]:hover:fill-gray-800  [&>svg]:active:fill-gray-900"
        data-cy="discount-close"
        onClick={onClose}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onClose();
          }
        }}
      >
        <CloseIcon tabIndex={0} data-cy="discount-popup" />
      </button>
    </div>
  );
}
